import { fetcher } from "helpers/fetcher";

import {
  TUpdateBusinessEstablishmentReq,
  TUpdateBusinessEstablishmentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateBusinessEstablishment = async (
  payload: TUpdateBusinessEstablishmentReq
) => {
  return await fetcher<
    TUpdateBusinessEstablishmentRes,
    TUpdateBusinessEstablishmentReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_BUSINESS_ESTABLISHMENT, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_BUSINESS_ESTABLISHMENT.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateBusinessEstablishment = async (
  payload: TUpdateBusinessEstablishmentReq
) => {
  return (await updateBusinessEstablishment(payload)).data;
};

mutationUpdateBusinessEstablishment._key = (
  payload: TUpdateBusinessEstablishmentReq
) => [ENDPOINT.CORPORATION.UPDATE_BUSINESS_ESTABLISHMENT.url, payload];
